interface DockLeftIconProps {
  size?: number;
  className?: string;
}

/** A panel outline with its left third filled — "park this at the left edge". */
export function DockLeftIcon({ size = 20, className = '' }: DockLeftIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect
        x="2.75"
        y="4.75"
        width="14.5"
        height="10.5"
        rx="1.75"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="4.25"
        y="6.25"
        width="3.5"
        height="7.5"
        rx="1"
        fill="currentColor"
      />
    </svg>
  );
}
